module.exports = __webpack_public_path__ + "static/services-e19e85ad3022ac5620dcc2d7437bfcf7.jpg";